import { Pipe, PipeTransform } from '@angular/core';
import TYPES from '../constants/types';

@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return this.extractAndFormatPrefix(value);
  }

  extractAndFormatPrefix(fullNumber: string | null | undefined): string {
    
    const knownCodes = this.getFullCleanCodes(TYPES.DATABASE.COUNTRY_GROUPS[1].countries);

    if (!fullNumber) return fullNumber ?? '';

    // 1. Remove qualquer caractere não numérico para garantir a comparação
    const cleanNumber = fullNumber.replace(/\D/g, '');

    // 2. Ordena os códigos por tamanho (decrescente).
    // Isso é crucial! Se tivermos EUA (1) e Bahamas (1242),
    // precisamos checar o mais longo primeiro para não dar "falso positivo" no 1.
    const sortedCodes = [...knownCodes].sort((a, b) => b.length - a.length);

    // 3. Procura qual código coincide com o início do número
    const foundCode = sortedCodes.find(code => cleanNumber.startsWith(code));

    if (foundCode) {
      return `(+${foundCode})${cleanNumber.replace(foundCode, '')}`
      
    }

    // Fallback: Se não achar na lista, retorna vazio ou o "+" genérico
    return fullNumber;
  }

  /**
   * Filtra a lista de países para retornar o DDI + Código de Área/Região concatenados.
   * Ex: De "+1-246", retorna "1246". De "+355", retorna "355".
   * @param countries A lista completa de países.
   * @returns Um array de strings limpas e únicas (ex: ["1246", "355", "93"]).
  */
  getFullCleanCodes(countries: any[]): string[] {
    
    const cleanCodes = countries.map(country => {
        // Usa regex para remover TODOS os caracteres que NÃO são dígitos (+, -, espaço, etc.)
        return country.dial_code.replace(/\D/g, ''); 
    });

    // Remove duplicatas (ex: se o país "EUA" e "Canadá" tiverem o dial_code apenas "+1")
    return Array.from(new Set(cleanCodes)).filter(code => code.length > 0);
  }

}
